import { MillOverview2Page } from "./MillOverview2Page";

const MillOverview2 = () => {
	return <MillOverview2Page />;
};

export default MillOverview2;
